import { useMemo } from "react";
import { useStandardProductCategories } from "shared/api/hooks/useStandardProductCategories";
import {
  isDevelopmentEnvironment,
  isTestEnvironment,
} from "shared/utils/checkEnvironment";

export const useMontageService = (enabled = true) => {
  const { standardProductCategories } = useStandardProductCategories({
    enabled,
  });

  // Product ID for free glue product
  const freeGlueProductID = isTestEnvironment()
    ? "67cab42792efb70002b3786f"
    : "67ca9929cec36d000238c29a";

  // Category code for free glue product
  const freeGlueCategoryCode = isTestEnvironment()
    ? "montageservice"
    : "achmonserv";

  // Find free glue category
  const freeGlueCategory = useMemo(() => {
    if (!standardProductCategories) return null;
    return standardProductCategories.find(
      (category) => category.code === freeGlueCategoryCode,
    );
  }, [standardProductCategories, freeGlueCategoryCode]);

  // Find free glue product
  const freeGlueProduct = useMemo(() => {
    return freeGlueCategory?.product.find(
      (product) => product.standardProduct.id === freeGlueProductID,
    )?.standardProduct;
  }, [freeGlueCategory, freeGlueProductID]);

  return { freeGlueProduct };
};
